"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const banner_1 = require("../common/banner");
const styledMessage_1 = require("../common/styledMessage");
const title_1 = require("../common/title");
const authForm_1 = __importDefault(require("../loginform/authForm"));
const registrationForm_1 = __importDefault(require("./registrationForm"));
const lexico = new lexico_1.default();
const RegisterForm = () => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(authForm_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Container, { style: {
                width: '360px',
                padding: 0,
                border: `1px solid ${theme.palette.tsGoColor.grayLightest}`,
                backgroundColor: theme.palette.tsGoColor.white,
            }, children: [(0, jsx_runtime_1.jsx)(banner_1.Banner, { className: "banner signin" }), (0, jsx_runtime_1.jsx)(title_1.Title, { children: lexico.trc('Component title', 'Create an account') }), (0, jsx_runtime_1.jsx)(registrationForm_1.default, {}), (0, jsx_runtime_1.jsxs)(styledMessage_1.StyledMessage, { children: ["By proceeding to create your account and use Tradeshift Go, you are agreeing to our \u00A0", (0, jsx_runtime_1.jsx)(material_1.Link, { underline: "none", href: "/tos", target: "_blank", rel: "noreferrer", children: "Terms of Service and Privacy Policy" }), "."] })] }) }));
};
exports.default = RegisterForm;
